// A fuller relative of Random Pick's short triangle pluck, not a bell/chime.
// Every voice uses the shared master gain, keeping mute and volume authoritative.
export const playKenoHit = (context, destination, step = 0) => {
  const index = Math.max(0, Math.min(9, Math.floor(step) || 0));
  const pitch = 520 + index * 28;
  const now = context.currentTime;
  const voice = (frequency, endFrequency, delay, duration, peak, type = 'sine') => {
    const oscillator = context.createOscillator(), gain = context.createGain();
    const start = now + delay;
    oscillator.type = type;
    oscillator.frequency.setValueAtTime(frequency, start);
    oscillator.frequency.exponentialRampToValueAtTime(endFrequency, start + duration);
    gain.gain.setValueAtTime(.0001, start);
    gain.gain.exponentialRampToValueAtTime(peak, start + .006);
    gain.gain.exponentialRampToValueAtTime(.0001, start + duration);
    oscillator.connect(gain); gain.connect(destination);
    oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
    oscillator.start(start); oscillator.stop(start + duration + .01);
  };
  voice(pitch * 1.025, pitch, 0, .115, .068, 'triangle');
  voice(pitch / 2, pitch / 2, 0, .085, .018);
  voice(pitch * 2, pitch * 2, .003, .065, .009);
};